<template>
  <v-container>
    <v-card>
      <v-card-title>
        ページが見つかりませんでした。
      </v-card-title>
      <v-card-text>
        URLを確認してください。
        <v-btn
          to="/"
        >
          戻る
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>

</template>